import React from 'react';
import { useLocation } from '@reach/router';
import { useStaticQuery, graphql } from 'gatsby';
import SectionHeader from './section-header';
import CaseStudyTile from './case-study-tile.js';
import articles, { withImages } from '../data/articles.js';
import '../styles/case-studies.scss';

// Shown on article and case study pages so each one links to other pieces, using the same
// tiles as the homepage case studies. Layout can't run a page query, so images come from a static query.
const RelatedArticles = ({ count = 3 }) => {
    const { pathname } = useLocation();
    const data = useStaticQuery(graphql`
        query RelatedArticleImages {
            allFile(filter: { sourceInstanceName: { eq: "assets" }, extension: { in: ["jpg", "jpeg", "png", "webp"] } }) {
                nodes {
                    name
                    childImageSharp {
                        gatsbyImageData(layout: CONSTRAINED, width: 1200)
                    }
                }
            }
        }
    `);
    const path = pathname.endsWith('/') ? pathname : `${pathname}/`;

    const sorted = withImages(articles, data);
    const index = sorted.findIndex(article => article.link === path);
    if (index === -1) return null;

    // Neighbours in date order (wrapping round), so every piece gets linked from others, not just the newest.
    const related = Array.from({ length: Math.min(count, sorted.length - 1) }, (_, i) => {
        const offset = i === 0 ? -1 : i;
        return sorted[(index + offset + sorted.length) % sorted.length];
    });

    return (
        <section className="ff case-studies related-articles">
            <SectionHeader heading="Keep reading" />
            <div className="grid">
                {related.map(article => (
                    <CaseStudyTile
                        key={article.link}
                        image={article.image}
                        client={article.client}
                        blurb={article.blurb}
                        tags={article.tags}
                        link={article.link}
                        type={article.type}
                        year={article.year}
                    />
                ))}
            </div>
        </section>
    );
};

export default RelatedArticles;
